<template>
  <div class="all-view padding-20 column-view scroll-y" v-loading="loading" element-loading-text="加载中...">

    <div class="column-view" v-if="!loading">

      <span style="font-weight: bold;font-size: 20px">{{meeting.meeting_name}}</span>

      <div class="row-view margin-top-15" style="align-items: normal">
        <div style="flex: 3" class="white-block-view-5px padding-15">

          <div class="row-view">
            <span style="font-weight: bold;font-size: 18px;flex: 1">打分角色明细</span>

            <el-button type="text" style="margin-left: 0" @click="onBatchPrint()">批量打印/下载</el-button>
          </div>

          <div class="table-title margin-bottom-10 margin-top-10">人员</div>
          <el-table :data="list3" style="width: 100%" border size="small">
            <el-table-column label="序号"  align="center" width="100px">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="姓名" prop="employee_name" align="center" width="100px">
            </el-table-column>
            <el-table-column label="职务"   align="center" width="100px">
              <template slot-scope="scope">
                {{scope.row.post_name}}
              </template>
            </el-table-column>
            <el-table-column label="说明" prop="post_note" align="center">
            </el-table-column>
            <el-table-column label="二维码"  align="center" width="150px">
              <template slot-scope="scope">
                <div class="row-view center-view">
                  <vue-qrcode :value="getCodeStr(scope.row.employee_id)" :options="{ width: 80 }" :key="'vueQrcode'+scope.$index"></vue-qrcode>
                  <div class="margin-left-10 column-view" style="justify-content: space-around">
                    <el-popover
                      placement="right"
                      trigger="click">
                      <div class="row-view center-view padding-10">
                        <vue-qrcode :value="getCodeStr(scope.row.employee_id)" :options="{ width: 250 }" :key="'vueQrcode'+scope.$index+scope.row.employee_id"></vue-qrcode>
                      </div>
                      <el-button  slot="reference" type="text" @click="onQrcodeShowClick(scope.row)">查看</el-button>
                    </el-popover>

                    <el-button type="text" style="margin-left: 0" @click="onQrcodePrintClick(scope.row,scope.$index)">打印</el-button>
                  </div>
                </div>

              </template>
            </el-table-column>
            <template #empty>
              <yc-no-content des="暂没有数据哦~"></yc-no-content>
            </template>
          </el-table>
        </div>

        <div class="flex-1 column-view  margin-left-15">
          <div class="white-block-view-5px column-view padding-15">
            <span style="font-weight: bold;font-size: 18px">被打分角色明细</span>
            <div class="table-title margin-bottom-10 margin-top-10">人员</div>
            <el-table :data="list1" style="width: 100%" border size="small">
              <el-table-column label="序号"  align="center" width="60px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="姓名" prop="employee_name" align="center" >
              </el-table-column>
              <el-table-column label="职务"   align="center" >
                <template slot-scope="scope">
                  {{scope.row.post_name}}
                </template>
              </el-table-column>
              <template #empty>
                <yc-no-content des="暂没有数据哦~"></yc-no-content>
              </template>
            </el-table>
          </div>
          <div class="white-block-view-5px column-view margin-top-10 padding-15">
            <div class="table-title margin-bottom-10 ">部门</div>
            <el-table :data="list2" style="width: 100%" border size="small">
              <el-table-column label="序号"  align="center" width="60px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="部门名称" prop="dept_name" align="center" >
              </el-table-column>
              <template #empty>
                <yc-no-content des="暂没有数据哦~"></yc-no-content>
              </template>
            </el-table>
          </div>


        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  name: "VoteDetail",
  components: {VueQrcode},
  data() {
    return {
      loading:false,
      id:'',
      type:'',
      year:'',
      deptId:'',
      position:'',
      time:'',

      meeting:{},

      url:'https://vote.sxhwj.cn/h5/#/?',
      list1: [],
      list2: [],
      list3: []
    }
  },
  methods: {
    onQrcodeShowClick(row){

    },

    //批量打印
    onBatchPrint(){
      let list =[];

      this.list3.forEach((item,index)=>{
        list.push({
          code:this.getCodeStr(item.employee_id),
          fileName:this.getFileName(item,index),
          name:item.employee_name,
          dept:'（'+item.post_name+'）'
        })
      })

      this.$router.push({path:'/print',query:{'meeting_name':this.meeting.meeting_name, 'year':this.year,'list':JSON.stringify(list)}})
    },


    padZero(num) {
      return String(num).padStart(2, '0');
    },


    getFileName(person,personIndex){
      return '山西年度考核测评-D1'+this.padZero(Number(this.position))+this.padZero(personIndex+1);
    },



    onQrcodePrintClick(row,index){
      let list=[{
        code:this.getCodeStr(row.employee_id),
        fileName:this.getFileName(row,index),
        name:row.employee_name,
        dept:'（'+row.post_name+'）'
      }]


      this.$router.push({path:'/print',query:{'meeting_name':this.meeting.meeting_name,'year':this.year,'list':JSON.stringify(list)}})
    },

    //封装二维码的内容
    // 会议年度 会议类型 会议id（副局长会参与多个部门，只能增加部门id 区分是否投过票）
    getCodeStr(id){

      // employee_id    meeting_type  year   meeting_id  唯一校验的时间戳
      let  code =this.url+'id='+id+'&type='+this.type+'&year='+this.year+'&dept='+this.deptId +'&time='+(Date.parse(this.time) +'-'+this.deptId);
      console.log("code===",code)
     return  code;
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.position=this.$route.query.position;
    this.deptId=this.id;
    this.time=this.$route.query.time;
    this.loading=true;

    this.http.api('meetingDetail',{'id':this.id})
        .then(res=>{

          if(res.status){
            let data = res.data;

            if(data.meeting){
              this.meeting=data.meeting
              this.type=data.meeting.meeting_type;
              this.year=data.meeting.year;

            }
            this.list3=data.rate_employee||[];
            this.list2=data.rated_dept||[];
            this.list1=data.rated_employee||[];

          }else{
            this.$commonUtils.showMessage(res.message,'error')
          }
          this.loading=false;
        })
        .catch(error=>{
          this.loading=false;
          this.$commonUtils.showMessage('请求失败,请稍后再试','error')
        })

  }
}
</script>

<style scoped>

</style>
